<template>
  <button v-if="tooltipMessage !== ''" :class="[buttonClass]" @click="handleClick" type="button" v-tooltip="tooltipMessage">
    <p>
      {{ text }}
    </p>
  </button>
  <button v-else :class="[buttonClass]" @click="handleClick" type="button">
    <p>
      {{ text }}
    </p>
  </button>
</template>

<script>
export default {
  name: "ButtonModals",
  props: {
    variant: {
      type: String,
      default: "btn-modal",
      validator: function (value) {
        const validVariants = ["main", "return", "return-red", "return-red-full", "btn-modal", "disabled"];
        return value.split(" ").every((v) => validVariants.includes(v) || v === "");
      },
    },
    text: {
      type: String,
    },
    tooltipMessage: {
      type: String,
      default: "",
    },
  },
  computed: {
    buttonClass() {
      return `${this.variant}`;
    },
  },
  methods: {
    handleClick() {
      this.$emit("handleClick");
    },
  },
};
</script>

<style scoped lang="scss">
.btn-modal {
  max-width: 180px;
  cursor: pointer;
  align-items: center;
  width: 100%;
  justify-content: center; 
  height: 40px;
  background: $solidWhite 0% 0% no-repeat padding-box;
  border-radius: 6px;
  border: 1px solid $solidBlue;
  letter-spacing: 0.1px;
  display: flex;
  font-size: 14px;
  font-weight: 100;

  &:active:not(.disabled) {
    transform: scale(0.97);
    transition: transform 0.05s ease;
  }

  p {
    font-family: "Rubik-Medium", sans-serif;
    white-space: nowrap;
  }
  &.main {
    background-color: $solidBlue !important;
    color: $solidWhite !important;
    @media (hover: hover) {
      &:hover {
        color: $solidWhite !important;
        background-color: $solidBlueHover !important;
      }
    }
  }
  &.return {
    border-color: $solidGray !important;
    p {
      color: $solidGray !important;
    }
  }
  &.return-red {
    border-color: $solidRed !important;
    p {
      color: $solidRed !important;
    }
  }
  &.return-red-full {
    border-color: $solidRed !important;
    background-color: $solidRed !important;
    @media (hover: hover) {
      &:hover {
        background-color: $solidRedHover !important;
        border-color: $solidRedHover !important;
      }
    }
    p {
      color: $solidWhite !important;
    }
  }
  &.shadow {
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  }
  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}
</style>
